import type {ReactElement} from 'react';
import {useState} from 'react';
import {useEffect} from 'react';
import React from 'react';
import styles from './poster-editor-toolbar.module.scss';
import {isTemplatesPopupHidden} from '@Components/poster-editor/library/poster-editor-library';

interface ToolbarProps {
  items: ReactElement<any>[];
  className?: string;
}

const ADD_ITEM_BAR_ITEM_WIDTH = 58;
const ADD_ITEM_BAR_ITEM_SPACING = 12;
const ADD_ITEM_BAR_SPSACING = 18;

export function PosterEditorToolbar({className = '', ...props}: ToolbarProps): ReactElement<any> {
  const [height, setHeight] = useState<number>();
  const [updatedItems, setUpdatedItems] = useState<ReactElement<any>[]>();

  useEffect((): void => {
    let numItems = props.items.length;
    if (isTemplatesPopupHidden()) {
      numItems -= 1;
    }
    const spacing = ADD_ITEM_BAR_ITEM_WIDTH * numItems + (numItems - 1) * ADD_ITEM_BAR_ITEM_SPACING + ADD_ITEM_BAR_SPSACING;
    setHeight(spacing);
    setUpdatedItems(updatedItems);
  }, [props.items.length]);

  return (
    <div
      style={{
        height: height,
      }}
      className={`${className} ${styles.container} shadow-floating-elevation-2 flex-column-align-center border-s-standard radius-8 spacing-p-2 js-blurred-during-onboarding`}
    >
      {props.items}
    </div>
  );
}
